<template>
  <div 
    class="skeleton-text" 
    :class="[variant, { 'mb-0': !spacing }]"
    :style="{ width: width, height: customHeight }"
  ></div>
</template>

<script>
export default {
  name: 'SkeletonText',
  props: {
    variant: {
      type: String,
      default: 'default', // 'title', 'subtitle', 'number', 'default'
      validator: (value) => ['title', 'subtitle', 'number', 'default'].includes(value)
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: null
    },
    spacing: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    customHeight() {
      if (this.height) return this.height;
      
      switch (this.variant) {
        case 'title':
          return '20px';
        case 'subtitle':
          return '14px';
        case 'number':
          return '32px';
        default:
          return '16px';
      }
    }
  }
}
</script>

<style scoped>
.skeleton-text {
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 8px;
}

.skeleton-text.mb-0 {
  margin-bottom: 0;
}

.skeleton-text.title {
  height: 20px;
  width: 60%;
}

.skeleton-text.subtitle {
  height: 14px;
  width: 40%;
}

.skeleton-text.number {
  height: 32px;
  width: 40%;
  margin-top: 12px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
